import { isEmpty as _isEmpty } from '@lodash';

export default function notEmpty(value: any): boolean {
    return !_isEmpty(value);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/validators/notEmpty.ts